import { eduIDApi } from "./common";
export const emailApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        makePrimaryEmail: builder.query({
            query: (body) => ({
                url: "primary",
                body,
            }),
            extraOptions: { service: "email" },
        }),
        verifyEmail: builder.query({
            query: (body) => ({
                url: "verify",
                body,
            }),
            extraOptions: { service: "email" },
        }),
        resendEmailCode: builder.query({
            query: (body) => ({
                url: "resend-code",
                body,
            }),
            extraOptions: { service: "email" },
        }),
        newEmail: builder.query({
            query: (body) => ({
                url: "new",
                body: Object.assign(Object.assign({}, body), { verified: false, primary: false }),
            }),
            extraOptions: { service: "email" },
        }),
        removeEmail: builder.query({
            query: (body) => ({
                url: "remove",
                body,
            }),
            extraOptions: { service: "email" },
        }),
    }),
});
